import React, { useState, useEffect } from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Image } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const View = (props) => {
  const { data } = props;

  // 1. Move Hooks to the top, before ANY conditional returns
  const [cellWidth, setCellWidth] = useState('six');

  useEffect(() => {
    // Check for data inside the effect rather than wrapping the effect
    const length = data?.cells?.length;
    if (!length) return;

    if (length % 4 === 0) {
      setCellWidth('three');
    } else if (length % 3 === 0) {
      setCellWidth('four');
    } else if (length % 2 === 0) {
      setCellWidth('six');
    }
    // 2. Pass an array literal [] and include the specific dependency
  }, [data?.cells?.length]);

  // 3. Early return happens AFTER hooks are declared
  if (!data) {
    return <div>missing data</div>;
  }

  const phone = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-telephone-fill"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
      />
    </svg>
  );

  const mail = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="2 6 34 25"
    >
      <path
        fillRule="evenodd"
        d="M3,29 L33,29 L33,6.999 L3,6.999 L3,29 Z M6.546,9 L29.454,9 L18,19.636 L6.546,9 Z M28.707,23.293 L23.07,17.656 L31,10.293 L31,27 L5,27 L5,10.293 L12.93,17.656 L7.293,23.293 L8.707,24.707 L14.396,19.018 L18,22.365 L21.604,19.018 L27.293,24.707 L28.707,23.293 Z"
      />
    </svg>
  );

  return (
    <div className="columns-view kontakt-kachel-wrapper">
      <div className="ui twelve column grid column-grid">
        {data.cells?.map((cell, index) => (
          <div
            key={index}
            className={`${cellWidth} wide computer twelve wide mobile six wide tablet column column-blocks-wrapper kontakt-kachel`}
          >
            <div className="kontakt-info-wrapper">
              {cell.image?.['@id'] &&
                cell.image?.image_scales?.image?.[0]?.scales?.preview
                  ?.download && (
                  <Image
                    src={flattenToAppURL(
                      `${cell.image['@id']}/${cell.image.image_scales.image[0].scales.preview.download}`,
                    )}
                    alt={`Kontaktbild ${cell.name}`}
                  />
                )}
              <div className="kontakt-daten">
                <h4 className="info-title">{cell.name}</h4>
                <div className="info-funktion">{cell.funktion}</div>
                {cell.phone && (
                  <div className="kontakt-column">
                    {phone}
                    <p>{cell.phone}</p>
                  </div>
                )}
                {cell.mail && (
                  <UniversalLink href={`mailto:${cell.mail}`}>
                    <div className="kontakt-column">
                      {mail}
                      <p>E-Mail</p>
                    </div>
                  </UniversalLink>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="divider" />
    </div>
  );
};

export default View;
